<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
      Diagnósticos
    </h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :disable-search="true"
      :route="'/patients/diagnoses/' + patient.id"
      no-data-label="Nenhum diagnóstico cadastrado"
      no-result-label="Nenhum diagnóstico encontrado"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4">
          <a :href="`/patients/diagnoses/download/` + row.id" target="_blank"
            ><font-awesome-icon
              icon="fa-eye"
              class="text-green-500 text-lg cursor-pointer"
          /></a>
        </div>
      </template>
      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4">
          <a :href="`/patients/diagnoses/download/` + row.id" target="_blank"
            ><font-awesome-icon
              icon="fa-eye"
              class="text-green-500 text-lg cursor-pointer"
          /></a>
        </div>
      </template>

      <template #after.reload-button>
        <!-- :disabled="Array.isArray(this.appointments()) && !this.appointments().length" -->
        <button
          v-if="user.role == 2"
          class="flex items-end font-roboto font-medium btn-primary uppercase"
          @click.prevent="openModalEdit({})"
          :title="
            Array.isArray(this.appointments()) && !this.appointments().length
              ? 'Nenhum agendamento'
              : ''
          "
        >
          <font-awesome-icon
            icon="fa-plus"
            class="text-white text-lg mr-0 lg:mr-2"
          /><span class="hidden lg:block"> Adicionar Diagnóstico</span>
        </button>
        <div
          v-if="
            Array.isArray(this.appointments()) && !this.appointments().length
          "
          class="block w-full text-center lg:hidden"
        >
          Nenhum agendamento
        </div>
      </template>
    </data-table>
  </div>

  <modal-edit-steps
    ref="modalEdit"
    :steps="stepItems"
    :modal-align="this.appointmentOpen() ? 'left' : 'center'"
    :modal-backdrop="!this.appointmentOpen()"
  >
    <template #content.start_diagnosis="{ item }">
      <select-input
        v-model="item.appointment_id"
        :error="item.errors.appointment_id"
        class="lg:pr-6 w-full lg:w-1/2"
        label="Atendimento vinculado"
      >
        <option :value="null" disabled class="hidden invisible">
          Atendimento vinculado
        </option>
        <option
          v-for="(value, name, index) in this.appointments()"
          :key="name"
          :value="name"
        >
          {{ this.$filters.formatDateTime(value, "dd/MM/yyyy - HH:mm") }}
        </option>
      </select-input>

      <select-input
        v-model="item.type"
        :error="item.errors.type"
        class="w-full mt-6 lg:mt-0 lg:w-1/2"
        label="Tipo do Diagnóstico"
      >
        <option :value="null" disabled class="hidden invisible">
          Tipo do Diagnóstico
        </option>
        <option
          v-for="(value, name, index) in this.prescription_types()"
          :key="name"
          :value="name"
        >
          {{ value }}
        </option>
      </select-input>
    </template>

    <template #content.generate_diagnosis="{ item }">
      <date-time-input
        v-model="item.date"
        :error="item.errors.date"
        class="w-full"
        label="Data de emissão"
      />
      <vue-select-input
        v-if="this.professional_addresses().length"
        :searchable="false"
        v-model="item.address"
        :options="this.professional_addresses()"
        :error="item.errors[`address.id`]"
        class="w-full mt-6"
        label="Local de atendimento"
        text="nenhum local de atendimento encontrado"
      >
        <template
          #option="{
            id,
            street,
            number,
            postcode,
            neighborhood,
            complement,
            state,
            city,
            cnes,
            phone,
          }"
        >
          {{ cnes }}
          <div>
            {{ street }}, {{ number }} - {{ postcode }} - {{ neighborhood }} -
            {{ city }} - {{ state }}
          </div>
          <div>{{ phone }}</div>
        </template>
        <template #selected-option="{ id, neighborhood, state, city }">
          {{
            neighborhood && state && city
              ? `${neighborhood} - ${city}/${state}`
              : "Local de atendimento"
          }}
        </template>
      </vue-select-input>
      <div
        v-if="!this.professional_addresses().length"
        class="flex flex-wrap mt-6"
      >
        <div class="w-full mb-2">Local de Atendimento</div>
        <text-input
          v-model="item.address.name"
          :error="item.errors[`address.name`]"
          class="lg:pr-6 w-full lg:w-6/12"
          placeholder="Nome"
        />
        <cep-input
          @updateAddress="
            (...args) => this.onUpdateAddress(item.address, ...args)
          "
          v-model="item.address.postcode"
          :error="item.errors[`address.postcode`]"
          class="pr-6 w-5/6 lg:w-1/2"
          placeholder="CEP"
        />
        <text-input
          v-model="item.address.street"
          :error="item.errors[`address.street`]"
          class="mt-6 lg:pr-6 w-full lg:w-2/3"
          placeholder="Logradouro"
        />
        <text-input
          v-model="item.address.number"
          :error="item.errors[`address.number`]"
          class="mt-6 w-full lg:w-1/3"
          placeholder="Número"
        />
        <text-input
          v-model="item.address.complement"
          :error="item.errors[`address.complement`]"
          class="mt-6 w-full"
          placeholder="Complemento"
        />
        <text-input
          v-model="item.address.neighborhood"
          :error="item.errors[`address.neighborhood`]"
          class="mt-6 lg:pr-6 w-full lg:w-1/3"
          placeholder="Bairro"
        />
        <text-input
          v-model="item.address.city"
          :error="item.errors[`address.city`]"
          class="mt-6 lg:pr-6 w-full lg:w-1/3"
          placeholder="Cidade"
        />
        <select-input
          v-model="item.address.state"
          :error="item.errors[`address.state`]"
          class="mt-6 w-full lg:w-1/3"
          placeholder="Estado"
        >
          <option :value="null" disabled class="hidden invisible">
            Estado
          </option>
          <option
            v-for="(value, name, index) in this.states_options()"
            :key="name"
            :value="name"
          >
            {{ value }}
          </option>
        </select-input>
        <text-input
          v-model="item.address.cnes"
          :error="item.errors[`address.cnes`]"
          class="mt-6 lg:pr-6 w-full lg:w-1/2"
          placeholder="CNES"
        />
        <mask-input
          :mask="['(##) ####-####', '(##) #####-####']"
          :clear-incomplete="true"
          v-model="item.address.phone"
          :error="item.errors[`address.phone`]"
          class="mt-6 w-full lg:w-1/2"
          placeholder="Telefone"
        />
        <switch-input
          v-model="item.address.save"
          class="w-full mt-6"
          labelChecked="Salvar endereço"
          labelUnchecked="Salvar endereço"
        />
      </div>
      <textarea-input
        v-model="item.description"
        :error="item.errors.description"
        class="mt-6 w-full"
        label="Diagnóstico"
      />
    </template>
    <template #content.upload="{ item }">
      <div class="w-full">
        Faça o upload do documento assinado digitalmente:
      </div>

      <file-input
        v-model="item.file"
        :error="item.errors.file"
        class="mt-6 w-full"
        type="file"
        accept="application/pdf"
        @change="uploadPDF(item)"
      />
    </template>
    <template #content.success>
      <div class="w-full text-center">
        <font-awesome-icon
          icon="fa-regular fa-circle-check"
          class="text-green-600 text-7xl mr-0 lg:mr-2"
        />
      </div>
      <div class="w-full text-center mt-5 uppercase">
        O documento foi enviado para o paciente
      </div>
    </template>
  </modal-edit-steps>
</template>

<script>
import { computed } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";

import axios from "axios";

import format from "date-fns/format";
import LoadingButton from "@/Shared/Components/LoadingButton";
import ModalEdit from "@/Shared/Modal/ModalEdit";
import ModalEditSteps from "@/Shared/Modal/ModalEditSteps";
import DataTable from "@/Shared/Components/DataTable";
import SwitchInput from "@/Shared/Fields/SwitchInput";
import TextInput from "@/Shared/Fields/TextInput";
import VueSelectInput from "@/Shared/Fields/VueSelectInput";
import DateTimeInput from "@/Shared/Fields/DateTimeInput";
import TextareaInput from "@/Shared/Fields/TextareaInput";
import FileInput from "@/Shared/Fields/FileInput";
import SelectInput from "@/Shared/Fields/SelectInput";
import TimeInput from "@/Shared/Fields/TimeInput";
import DateInput from "@/Shared/Fields/DateInput";
import MaskInput from "@/Shared/Fields/MaskInput";
import CepInput from "@/Shared/Fields/CepInput";
import { Inertia } from "@inertiajs/inertia";

export default {
  inject: [
    "patient",
    "professionals",
    "professional_addresses",
    "appointments",
    "prescription_types",
    "states_options",
    "loadOptions",
    "appointmentOpen",
  ],
  components: {
    LoadingButton,
    ModalEdit,
    ModalEditSteps,
    DataTable,
    SwitchInput,
    TextInput,
    VueSelectInput,
    DateTimeInput,
    TextareaInput,
    FileInput,
    SelectInput,
    TimeInput,
    DateInput,
    MaskInput,
    CepInput,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user);
    return { user };
  },
  data() {
    return {
      loadTable: true,
      stepItems: [
        {
          idStep: "start_diagnosis",
          title: "Gerar diagnóstico",
          submitCallback: (item, callback) => {
            let success = false;
            item.post(`/patients/diagnoses/validate-step-one`, {
              forceFormData: true,
              onFinish: () => {
                let success = false;
                if (!Object.keys(item.errors).length) {
                  success = true;
                }
                callback(success);
                if (item.type == "document") {
                  this.$refs.modalEdit.$refs.steps.selectedItemIndex = 2;
                }
              },
            });
            return success;
          },
        },
        {
          idStep: "generate_diagnosis",
          title: "Dados do diagnóstico",
          submitCallback: (item, callback) => {
            let success = false;

            item.post(`/patients/diagnoses/validate-step-two`, {
              forceFormData: true,
              onFinish: () => {
                if (!Object.keys(item.errors).length) {
                  success = true;

                  axios
                    .post("/patients/pdf/generate", {
                      type_document: "diagnosis",
                      appointment_id: item.appointment_id,
                      date: item.date,
                      description: item.description,
                      professional_id: item.professional?.id,
                      address_id: item.address?.id,
                      patient_id: this.patient.id,
                      address_name: item.address?.name,
                      address_postcode: item.address?.postcode,
                      address_street: item.address?.street,
                      address_number: item.address?.number,
                      address_complement: item.address?.complement,
                      address_neighborhood: item.address?.neighborhood,
                      address_city: item.address?.city,
                      address_state: item.address?.state,
                      address_cnes: item.address?.cnes,
                      address_phone: item.address?.phone,
                    })
                    .then(() => {
                      callback(success);
                      this.$refs.modalEdit.$refs.steps.selectedItemIndex = 3;
                      this.reloadTable();
                      this.loadOptions();
                    });
                } else callback(success);
              },
            });
            return success;
          },
        },
        {
          // idStep: 'upload',
          // title: 'Documento enviado para o paciente',
          // submitCallback: (item, callback) => {
          //   let success = false;
          //   item.post(`/patients/diagnoses/` + this.patient.id, {
          //       forceFormData: true,
          //       onFinish: () => {
          //         let success = false;
          //         if(!Object.keys(item.errors).length) {
          //             success = true;
          //             this.reloadTable();
          //             this.loadOptions();
          //         }
          //         callback(success);
          //       }
          //   });
          //   return success;
          // },
          // backCallback: (item, callback) => {
          //   let success = true;
          //   callback(success);
          //   if(item.type == 'document') {
          //     this.$refs.modalEdit.$refs.steps.selectedItemIndex = 0;
          //   }
          //   return success;
          // }
          idStep: "upload",
          title: "Documento enviado para o paciente",
          submitCallback: async (item, callback) => {
            let success = false;

            if (!item.temp_file) {
              this.$toast.error(
                "É necessário fazer o upload do arquivo PDF antes de continuar."
              );
              return callback(false);
            }

            item.post(`/patients/diagnoses/${this.patient.id}`, {
              preserveScroll: true,
              forceFormData: true,
              onFinish: () => {
                if (!Object.keys(item.errors).length) {
                  success = true;
                  this.reloadTable();
                  this.loadOptions();
                }
                callback(success);
              },
            });

            return success;
          },
        },
        {
          idStep: "success",
          title: "Diagnóstico enviado para o paciente",
        },
      ],
      columns: [
        {
          uniqid: "diagnosis_date_start",
          label: "Atendimento",
          field: "appointments.date_start",
          visible: true,
          sortable: false,
          sortOrder: "asc",
          classes: "px-4 py-3 border-b text-sm",
          headerClass: "p-4 text-left",
          format: (val, row) => row.appointment ? format(new Date(row.appointment?.date_start), "dd/MM/yyy - HH:mm") : '',
        },
        {
          uniqid: "diagnosis_created_at",
          label: "Data do documento",
          field: "created_at",
          visible: true,
          sortable: true,
          sortOrder: "asc",
          classes: "px-4 py-3 border-b text-sm",
          headerClass: "p-4 text-left",
          format: (val, row) =>
            format(new Date(row.created_at), "dd/MM/yyy HH:mm"),
        },
        {
          uniqid: "actions",
          label: "Ações",
          field: "id",
          visible: true,
          align: "center",
          classes: "py-3 border-b",
          headerClass: "p-4",
        },
      ],
    };
  },
  methods: {
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        appointment_id: item.appointment_id,
        type: item.type,
        description: item.description,
        date: item.date,
        file: item.file,
        temp_file: null,
        professional: item.professional ?? null,
        address: item.address ?? {},
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => (this.loadTable = true), 10);
    },
    onUpdateAddress(address, json) {
      address.city = json.localidade;
      address.state = json.uf;
      address.street = json.logradouro;
      address.neighborhood = json.bairro;
    },
    async uploadPDF(item) {
      const file = item.file;
      const patientId = this.patient?.id ?? this.patient()?.id;

      if (!file) {
        this.$toast.error("Nenhum arquivo selecionado.");
        return;
      }

      const form = new FormData();
      form.append("file", file);
      item.temp_file = null;

      Inertia.post(`/patients/diagnoses/${patientId}/upload-temp`, form, {
        preserveScroll: true,
        forceFormData: true,
        onSuccess: (page) => {
          const filename = page.props?.flash?.filename;

          if (filename) {
            item.temp_file = filename;
          } else {
            this.$toast.error("Arquivo não processado corretamente.");
            item.file = null;
          }
        },
        onError: (errors) => {
          this.$toast.error("Erro ao enviar o arquivo.");
          item.file = null;
        },
        onFinish: () => {
          console.log("🔁 Upload finalizado.");
        },
      });
    },
  },
};
</script>
